<template>
  <div
    id="confirmation-apply-for"
    class="fixed-bottom py-2"
    :style="{'border-color': `${getPrimaryColor} !important`}"
  >
    <!-- START: SKELETON LOADING -->
    <div
      v-if="!hasInfoVacancy('company')"
      class="container"
    >
      <div class="row">
        <div
          class="description col-12 col-sm-8 col-md-8 col-8 align-self-center skeleton-loading d-none d-sm-block"
        >
          <div class="text-skeleton my-2" />
          <div class="text-skeleton my-2" />
        </div>
        <div class="info-button col align-self-center">
          <button
            class="btn btn-round text-white pull-right w-xs-100"
            style="width: 140px; height: 36px; background-color: #ccc; "
          />
        </div>
      </div>
    </div>
    <!-- END: SKELETON LOADING -->

    <!-- START: INFO LOAD -->
    <div
      v-if="hasInfoVacancy('company')"
      class="container"
    >
      <!-- START: APPLY VACANCY -->
      <div
        v-if="!hasApplied(vacancy.vacancy[JSON.parse(Object.keys(vacancy.vacancy))])"
        class="row"
      >
        <div class="description col-12 col-sm-8 col-md-8 col-8 align-self-center d-none d-sm-block">
          <h5
            class="font-weight-bold m-0"
            :style="{'color': `${getPrimaryColor} !important`}"
          >
            <strong>Deseja se candidatar a vaga?</strong>
          </h5>
          <p class="m-0">
            Após a candidatura a empresa vai analisar seu perfil,
            <b>fique atento ao seu email e telefone</b>.
          </p>
        </div>
        <div
          v-if="currentUserIsCandidate"
          class="info-button col align-self-center"
        >
          <!-- button apply for vacancy -->
          <b-link
            v-if="!hasApplied(vacancy.vacancy[JSON.parse(Object.keys(vacancy.vacancy))])"
            :id="`apply-${vacancy.vacancy[JSON.parse(Object.keys(vacancy.vacancy))].id}`"
            class="btn btn-round bg-color-primary text-white pull-right w-xs-100"
            :style="{'background-color': `${secondaryColor}` + ' !important'}"
            :href="`${vacancy.vacancy[JSON.parse(Object.keys(vacancy.vacancy))].links.candidateTo}`"
          >
            Candidatar-se
          </b-link>
        </div>
        <div
          v-if="!userIsLoggedIn"
          class="info-button col align-self-center"
        >
          <b-link
            :href="signInUrl(getCurrentScopedCompanySubdomain)"
            class="btn btn-round bg-color-primary text-white pull-right w-xs-100"
            :style="{'background-color': `${getSecondaryColor}` + ' !important'}"
          >
            Candidatar-se
          </b-link>
        </div>
      </div>
      <!-- END: APPLY VACANCY -->

      <!-- START: APPLYED VACANCY -->
      <div
        v-if="hasApplied(vacancy.vacancy[JSON.parse(Object.keys(vacancy.vacancy))])"
        class="row"
      >
        <div
          v-if="currentUserIsCandidate"
          class="description col-12 col-sm-12 col-md-12 col-12 align-self-center"
        >
          <h5
            class="font-weight-bold m-0 text-center"
            :style="{'color': `${getPrimaryColor} !important`}"
          >
            <strong>Candidatura confirmada</strong>
          </h5>
          <p class="m-0 text-center">
            Você candidatou-se em
            <strong>
              {{ vacancy.vacancy[JSON.parse(Object.keys(vacancy.vacancy))].meta.candidatureAt }}
            </strong>

            <template v-if="vacancy.vacancy[JSON.parse(Object.keys(vacancy.vacancy))].attributes.showProgressToCandidates">
              e seu status nesse processo é
              <strong>
                {{ vacancy.vacancy[JSON.parse(Object.keys(vacancy.vacancy))].meta.candidatureStatus }}
              </strong>
            </template>
          </p>
        </div>
      </div>
      <!-- END: APPLYED VACANCY -->
    </div>
    <!-- END: INFO LOAD -->
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import Vue from 'vue/dist/vue.esm';
import axios from 'axios';
import VueAxios from 'vue-axios';

import mixins from '../mixins/mixins';

Vue.use(VueAxios, axios);

export default {
  name: 'ApplyBar',
  mixins: [mixins],
  data() {
    return {
      actualVacancy: {},
      currentdomain: '',
      separate: window.location.host.split('.'),
    };
  },
  computed: {
    ...mapState('UserStore', [
      'currentUser',
    ]),
    ...mapState('CompanyStore', [
      'currentScopedCompany',
    ]),
    ...mapState('VacancyStore', [
      'vacancy',
      'vacLoading',
    ]),
    ...mapGetters('UserStore', [
      'currentUserIsAdmin',
      'currentUserIsCompanyUser',
      'currentUserIsCandidate',
      'userIsLoggedIn',
    ]),
    ...mapGetters('CompanyStore', [
      'currentScopedCompanyManagerOther',
      'getPrimaryColor',
      'getSecondaryColor',
      'getCurrentScopedCompanySubdomain',
    ]),
  },
  mounted() {
    this.separate.shift();
    this.currentdomain = this.separate.join('.');
  },
  methods: {
    hasApplied(vac) {
      return vac.meta.candidature;
    },
    hasInfoVacancy(info) {
      return this.vacancy[info] !== undefined;
    },

    // ==========================
    // Method apply vacancy and swal
    // ==========================
    signInUrl(currentScopedCompanySubdomain) {
      let url = `${this.protocol}candidatos.${this.currentdomain}/sign-in`;
      const params = [];
      if (currentScopedCompanySubdomain.subdomain) {
        params.push(`subdomain=${currentScopedCompanySubdomain.subdomain}`);
      }
      if (this.vacancy.vacancy) {
        params.push(`slug=${this.vacancy.vacancy[JSON.parse(Object.keys(this.vacancy.vacancy))].attributes.slug}`);
      }
      if (params.length) {
        url += `?${params.join('&')}`;
      }
      return url;
    },
  },
};
</script>

<style lang="scss" scoped>
#confirmation-apply-for {
  z-index: 1;
}
.popover {
  pointer-events: none !important;
  .popover-header {
    .size {
      height: 20px;
    }

    .representing-match {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      top: 14px;

      img:last-child {
        margin-left: -14px;
      }
    }
  }
}
</style>
